<template>
  <div>
    <div class="table-responsive col-lg-12">
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Name</th>
          <th>Client</th>
          <th>Integration</th>
          <th># Domains</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="host in f.hosts" :key="host.id">
          <td>
            {{ host.name }}
          </td>
          <td>{{ host.client.name }}</td>
          <td>{{ host.integration || '/' }}</td>
          <td>0</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  mounted () {
    if (!this.f.client) {
      this.$store.dispatch('loadFilters')
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Accounts/Hosts/List.vue